import { Component, Input, OnInit, ViewChild, HostBinding } from '@angular/core';

import { OpenTooltipComponent } from '../open-tooltip/open-tooltip.component';

@Component({
  selector: 'open-tile-detail',
  templateUrl: './open-tile-detail.component.html',
  styleUrls: ['./open-tile-detail.component.scss']
})
export class OpenTileDetailComponent implements OnInit {
  @Input() componentDetails: any;

  @HostBinding('className') componentClass: string = '';

  textPadded:string = '';
  clickable:boolean = false;
  clickableConst:Array<string> = [
    'help',
    'download',
    'link'
  ];

  @ViewChild(OpenTooltipComponent) openTooltip!: OpenTooltipComponent;

  ngOnInit(): void {
    this.clickable = this.clickableConst.some((type) => type === this.componentDetails?.settings?.action?.type);

    if (this?.componentDetails?.settings?.margin) {
      this.componentClass += this.componentDetails?.settings?.margin?.top ? `margin-top-${this.componentDetails?.settings?.margin?.top}` : '';
      this.componentClass += this.componentDetails?.settings?.margin?.bottom ? ` margin-bottom-${this.componentDetails?.settings?.margin?.bottom}` : '';
    }
  }

  triggerAction() {
    if (this.componentDetails?.settings?.action?.type === 'help') {
      this.triggerTooltip();
    }
  }

  triggerTooltip() {
    const tooltip = this.openTooltip;
    if (tooltip) {
      tooltip.openTooltip();
    }
  }

  setContainerClasses() {
    const classes = [];
    if (this.componentDetails?.settings?.class) {
      classes.push(this.componentDetails?.settings?.class);
    }
    if (this.componentDetails?.settings?.type) {
      classes.push(`is-${this.componentDetails?.settings?.type}`);
    }
    if (this.componentDetails?.settings?.layout) {
      classes.push(`is-${this.componentDetails?.settings?.layout}`);
    }
    if (this.clickable) {
      classes.push('clickable');
    }
    return classes;
  }
}



